import { Card } from "antd";
import { Col, Row, Table } from "react-bootstrap";
import { BsCashCoin } from "react-icons/bs";
import UPI from "../../../assets/images/upi.png";
import CASH from "../../../assets/images/cash.png";
import { FaCreditCard } from "react-icons/fa";

const SalesDataTable = (props: any) => {
  return (
    <div>
      <Row>
        <Col lg={3} md={4} sm={"6"} xs={12} className="mt-2">
          <Card>
            <div className="report-Box">
              <div>
                <div className="report-text1">TOTAL AMOUNT</div>
                <div className="report-text2">
                  {(Number(props?.total) - Number(props?.cardBalance)).toFixed(
                    2
                  )}
                </div>
              </div>
              <div>
                <img src={CASH} style={{ width: 50 }} />
              </div>
            </div>
          </Card>
        </Col>
        <Col lg={3} md={4} sm={"6"} xs={12} className="mt-2">
          <Card>
            <div className="report-Box">
              <div>
                <div className="report-text1">CARD BALANCE</div>
                <div className="report-text2">
                  {Number(props?.cardBalance).toFixed(2)}
                </div>
              </div>
              <div>
                <FaCreditCard size={40} color="grey" />
              </div>
            </div>
          </Card>
        </Col>
        <Col lg={3} md={4} sm={"6"} xs={12} className="mt-2">
          <Card>
            <div className="report-Box">
              <div>
                <div className="report-text1">UPI</div>
                <div className="report-text2">
                  {props?.methodSum?.upi
                    ? Number(props?.methodSum?.upi).toFixed(2)
                    : Number(0).toFixed(2)}
                </div>
              </div>
              <div>
                <img src={UPI} style={{ width: 100 }} />
              </div>
            </div>
          </Card>
        </Col>
        <Col lg={3} md={4} sm={"6"} xs={12} className="mt-2">
          <Card>
            <div className="report-Box">
              <div>
                <div className="report-text1">CASH</div>
                <div className="report-text2">
                  {props?.methodSum?.cash
                    ? Number(props?.methodSum?.cash).toFixed(2)
                    : Number(0).toFixed(2)}
                </div>
              </div>
              <div>
                <BsCashCoin size={40} color="grey" />
              </div>
            </div>
          </Card>
        </Col>
      </Row>
      <br />
      <Table bordered>
        <thead>
          <tr>
            <td className="report-headtd">Day</td>
            <td className="report-headtd">Payment Method</td>
            <td className="report-headtd" style={{ textAlign: "right" }}>
              Total
            </td>
          </tr>
        </thead>
        <tbody>
          {props?.data?.map((item: any) => {
            return (
              <tr key={item?.date}>
                <td>
                  <div className="report-titletd">{item?.date}</div>
                </td>
                <td style={{ width: 300 }}>
                  <Table
                    bordered
                    style={{ marginBottom: -10 }}
                    className="report-subtable"
                  >
                    <tbody>
                      {item?.transactions?.map((trans: any) => {
                        return (
                          <tr>
                            <td style={{ padding: 1, paddingLeft: 5 }}>
                              {trans?.paymentMethod}
                            </td>
                            <td
                              style={{
                                padding: 1,
                                paddingLeft: 5,
                                paddingRight: 5,
                                textAlign: "right",
                              }}
                            >
                              {Number(trans?.totalAmount).toFixed(2)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </td>
                <td style={{ width: 300 }}>
                  <div className="report-sumtd">
                    {Number(item?.totalAmount).toFixed(2)}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default SalesDataTable;
